import React, {useCallback} from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import useTranslationAdmin from "../useTranslationAdmin";
import useShowLoader from "../../common/loading-widgets/useShowLoader";
import Table from "react-bootstrap/Table";
import WaitForData from "../../common/data-fetching/WaitForData";
import useQueryEmployerAdminSearch from "../search/useQueryEmployerAdminSearch";
import TypeUtils from "../../../utils/TypeUtils";
import TrueIcon from "@material-ui/icons/Check";
import TruncateText from "./TruncateText";
import ActionLink from "../../common/widgets/ActionLink";
import {useHistory} from "react-router-dom";
import * as ROUTES from "../../../constants/routes";
import queryString from "query-string";
import DisplayDayIso from "./DisplayDayIso";
import JobByEmployerCountItem from "../search/JobByEmployerCountItem";
import PublishedJobByEmployerCountItem from "../search/PublishedJobByEmployerCountItem";
import JobStatusEnum from "../../jobs/JobStatusEnum";
import AdminTooltip from "./AdminTooltip";

export default function EmployerList(/*props*/) {
  const {
    data: employers,
    loading,
    errors,
  } = useQueryEmployerAdminSearch(
    1000,
    {},
    "CREATED_AT_DESC"
  );

  const { t, loading: tLoading } = useTranslationAdmin();
  useShowLoader(tLoading || loading, "EmployerList");

  const history = useHistory();

  const goToAllJobs = useCallback(employerId => {
    history.push({
      pathname: ROUTES.EMPLOYER_ADMIN_JOBS,
      search: queryString.stringify({ employerId } ),
    });
  }, [history]);

  const goToPublishedJobs = useCallback(employerId => {
    history.push({
      pathname: ROUTES.EMPLOYER_ADMIN_JOBS,
      search: queryString.stringify({ employerId, status: JobStatusEnum.PUBLISHED } ),
    });
  }, [history]);

  const columnsLabels = [
    t("admin:admin_employer_date_column_label"),
    t("admin:admin_employer_name_column_label"),
    t("admin:admin_employer_phone_column_label"),
    t("admin:admin_employer_email_column_label"),
    t("admin:admin_employer_company_column_label"),
    t("admin:admin_employer_companyPresentation_column_label"),
    t("admin:admin_employer_active_column_label"),
    t("admin:admin_employer_job_count_column_label"),
    t("admin:admin_employer_publishedJob_count_column_label")
  ];

  return (
    <>
      <WaitForData
        loading={loading}
        errors={errors}
        onLoaded={() => (
          <Row className="widget-block">
            <Col>
              <Table striped hover responsive>
                <thead>
                  <tr>
                    <th>#</th>
                    {columnsLabels.map((item, i) => (
                      <td key={i}>{item}</td>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {employers["nodes"].map((item, i) => (
                    <tr key={i}>
                      <th><AdminTooltip text={item._id} title={"ID"}>{i + 1}</AdminTooltip></th>
                      <td><DisplayDayIso date={item.createdAt} /></td>
                      <td>{TypeUtils.arrayRemoveNullOrEmpty([item.firstName, item.lastName]).join(" ")}</td>
                      <td>{item.phone}</td>
                      <td><TruncateText title={t("admin:admin_employer_email_column_label")} text={item.email} length={15}/></td>
                      <td><TruncateText title={t("admin:admin_employer_company_column_label")} text={item.organization.company} length={15}/></td>
                      <td><TruncateText title={t("admin:admin_employer_companyPresentation_column_label")} text={item.organization.companyPresentation} length={15}/></td>
                      <td>{item.isActiveAccount ? <TrueIcon/> : ""}</td>
                      <td><ActionLink onClick={() => goToAllJobs(item._id)}><JobByEmployerCountItem employerId={item._id}/></ActionLink></td>
                      <td><ActionLink onClick={() => goToPublishedJobs(item._id)}><PublishedJobByEmployerCountItem employerId={item._id}/></ActionLink></td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Col>
          </Row>
        )}
      />
    </>
  );
}
